import { createGlobalStyle } from 'styled-components';

export const ResetStyles = createGlobalStyle`
html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,
a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,
strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,
label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,
details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,
section,summary,time,mark,audio,video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
  display: block;
}
body {
  line-height: 1;
  word-break: break-word;
}
ol,ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,blockquote:after,q:before,q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
html * {
  box-sizing: border-box;
  font-family: "manrope", sans-serif;
}
body {
  font-family: "manrope", sans-serif;
  background: #ffffff;
  color: #1D1E20;
}
a {
  color: inherit;
  text-decoration: none;
}
img {
  height: auto;
  width: 100%;
}
input:not([type="range"]) {
  -webkit-appearance: none;
  border: none;
  background: none;
}
input,
button {
  &:focus {
    outline: unset;
  }
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: none !important;
  color: inherit;
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  box-shadow: 0 0 0 30px white inset !important;
}
button {
  margin: 0;
}
main {
  max-width: 376px;
  min-height: 100vh;
  margin: 0 auto;
  background: white;
  position: relative;
}
.MuiFormControl-root {
  width: 100%;
}
.MuiListItemIcon-root {
  width: 24px;
  min-width: 24px !important ;
  height: 24px;
  margin-right: 12px;
  img {
    width: 24px;
  }
}
input::-ms-reveal,input::-ms-clear {
  display: none;
}
#imbee {
  .imbee-chat-messages ul li > div.me > div.imbee-message > div.imbee-text-time {
    background-color: #dadada !important;
    color: #040404 !important;
  }
  .imbee-input-field.imbee-input-field-show {
    background: #dadada !important;
  }
  .imbee-send .imbee-send-btn svg {
    fill: #0094d9 !important;
    color: #0094d9 !important;
  }
}
`;

export default ResetStyles;
